import { TAppDispatch } from 'store/types'
import { getUserCredits_API } from 'api'
import creditsSlice from 'store/features/credits/slice'
import { ErrorKeys } from 'consts/errorKeys'
import { captureException } from '@sentry/react'
import { ApiError, ReduxThunkError } from 'utils/errors'
import { handleApiError } from 'store/utils'

const { actions } = creditsSlice

const getUserCredits = () => async (dispatch: TAppDispatch) => {
  try {
    const response = await getUserCredits_API()
    dispatch(actions.setUserCredits(response.data.availableCredits))
  } catch (error) {
    if (!(error instanceof ApiError)) {
      captureException(new ReduxThunkError(error))
    }
    dispatch(handleApiError(ErrorKeys.GENERAL_API_ERROR))
  }
}

export const creditsThunks = {
  ...actions,
  getUserCredits
}
